module.exports = __webpack_public_path__ + "static/media/file-audio.9db9c034.svg";